import React from 'react';
import { Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Student } from '@/types';
import { columns } from './columns';
import { getActionColumn } from './getActionColumn';
import { useTablePagination } from './hooks/useTablePagination';
import { useTableSearch } from './hooks/useTableSearch';
import { useTableSort } from './hooks/useTableSort';
import { TablePagination } from './components/TablePagination';
import { TableToolbar } from './components/TableToolbar';
import { NoRowsOverlay } from './components/NoRowsOverlay';
import { tableStyles } from './styles';

interface StudentTableProps {
  students: Student[];
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

export const StudentTable: React.FC<StudentTableProps> = ({ 
  students, 
  onEdit, 
  onDelete 
}) => {
  const {
    searchQuery,
    handleSearch,
    filteredStudents
  } = useTableSearch(students);

  const {
    page,
    pageSize,
    // pageCount,
    startIndex,
    endIndex,
    handlePageChange,
    handlePageSizeChange
  } = useTablePagination(filteredStudents.length);

  const {
    sortModel,
    handleSortModelChange
  } = useTableSort();

  const allColumns = React.useMemo(() => [
    ...columns,
    getActionColumn(onEdit, onDelete)
  ], [onEdit, onDelete]);

  const currentPageData = filteredStudents.slice(startIndex, endIndex);

  return (
    <Paper sx={tableStyles.root}>
      <TableToolbar
        searchQuery={searchQuery}
        onSearch={handleSearch}
      />
      
      <DataGrid
        rows={currentPageData}
        columns={allColumns}
        disableRowSelectionOnClick
        hideFooter
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        components={{
          NoRowsOverlay
        }}
        sx={tableStyles.dataGrid}
      />

      <TablePagination
        page={page}
        pageSize={pageSize}
        totalItems={filteredStudents.length}
        startIndex={startIndex}
        endIndex={endIndex}
        onPageChange={handlePageChange}
        onPageSizeChange={(event) => handlePageSizeChange(Number(event.target.value))}
      />
    </Paper>
  );
};